<template>
    <LayoutFooter :data="content?.config" />
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
    content: Schemas['CmsElementA4gFooter']
}>()
</script>
